import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ReelPlayerLabels } from "@digital-twins/deck-ui/components/reel/reelPages";

/** The player's localized labels, shared by the overlay and the rail embed. */
export function useReelPlayerLabels(): ReelPlayerLabels {
  const { t } = useTranslation("app");

  return useMemo<ReelPlayerLabels>(
    () => ({
      region: (name) => t("studyLobby.reel.dialogTitle", { name }),
      slider: t("studyLobby.reel.slider"),
      slidePosition: (current, total, title) => t("studyLobby.reel.slidePosition", { current, total, title }),
      previous: t("studyLobby.reel.previous"),
      next: t("studyLobby.reel.next"),
      autoplay: t("studyLobby.reel.autoplay"),
      pause: t("studyLobby.reel.pause"),
      lineupPosition: (current, total) => t("studyLobby.reel.lineupPosition", { current, total }),
      video: t("studyLobby.reel.video"),
      aboutStimulus: (name) => t("studyLobby.reel.aboutStimulus", { name }),
      respondents: (count) => t("studyLobby.reel.respondents", { count }),
      openReport: t("studyLobby.reel.openReport"),
    }),
    [t],
  );
}
